export default class HeaderController {
	constructor() {
		this.onEventTriggered = ::this.onResizeOrScroll;
		this.hero = document.querySelector("#hero");
		this.header = document.querySelector("#header-content");
		this.initEvents();
	}

	getTopOffset(element) {
		return element.getBoundingClientRect().top;
	}

	getHeight(element) {
		return element.getBoundingClientRect().height;
	}

	onResizeOrScroll(e) {
		if (
			window.scrollY >=
			this.getHeight(this.hero) - this.getHeight(this.header)
		) {
			if (this.header.classList.contains("is-active")) return;
			this.header.classList.add("is-active");
		} else {
			if (this.header.classList.contains("is-active")) {
				this.header.classList.remove("is-active");
			}
		}
	}

	initEvents() {
		window.addEventListener("scroll", this.onEventTriggered);
		window.addEventListener("resize", this.onEventTriggered);
	}
}



// WEBPACK FOOTER //
// ./Components/HeaderController.js